document.addEventListener('DOMContentLoaded', function () {
  let elem = document.querySelector('.main-carousel-videos');
  let flkty = new Flickity(elem, {
    // options
    cellAlign: 'left',
    contain: true,
    prevNextButtons: false,
    wrapAround: true,
  });

  let muteButtons = document.querySelectorAll(".section-videos .custom-mute-button");
  let playPauseButtons = document.querySelectorAll(".section-videos .custom-play-button");
  let videos = document.querySelectorAll('.main-carousel-videos video');
  
  playPauseButtons.forEach(function (btn, index) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      
      // Pause all videos
      videos.forEach(function (video, i) {
        if (index !== i && !video.paused) {
          video.pause();
          playPauseButtons[i].classList.remove('pause');
        }
      });
  
      let currentVideo = videos[index];
  
      if (currentVideo.paused) {
        // Play the clicked video
        currentVideo.play();
        btn.classList.add('pause'); // Add 'pause' class to indicate pause state
      } else {
        // Pause the clicked video
        currentVideo.pause();
        btn.classList.remove('pause'); // Remove 'pause' class to indicate play state
      }
    });
  });

  let customMuteBtn = document.querySelectorAll(".section-tii .custom-mute-button");
  customMuteBtn.forEach(function (btn) {
    btn.addEventListener("click", function(e) {
      e.preventDefault();

      let currentVideo = this.nextElementSibling;
      if (currentVideo.muted === true) {
        currentVideo.muted = false;
        btn.classList.add('unmute');
      }
      else if (currentVideo.muted === false) {
        currentVideo.muted = true;
        btn.classList.remove('unmute');
      }
    });
  });
  

  let muteBtn = document.querySelectorAll(".section-videos .custom-mute-button");
  muteBtn.forEach(function (btn) {
    btn.addEventListener("click", function(e) {
      e.preventDefault();

      let currentVideo = this.parentElement.querySelector('video');
      if (currentVideo.muted === true) {
        videos.forEach(function (video, i) {
            video.muted = false;
        });
         muteButtons.forEach(function (mutebtn, i) {
          mutebtn.classList.add('unmute');
        });
        currentVideo.muted = false;
        btn.classList.add('unmute');
      }
      else if (currentVideo.muted === false) {
        videos.forEach(function (video, i) {
            video.muted = true;
        });
         muteButtons.forEach(function (mutebtn, i) {
          mutebtn.classList.remove('unmute');
        });
        currentVideo.muted = true;
        btn.classList.remove('unmute');
      }
    });
  });

  function playPauseVideoOnScroll() {
    let videos = document.querySelectorAll('.main-carousel-videos video');
    let playPauseButtons = document.querySelectorAll(".section-videos .custom-play-button");
    let section = document.querySelector('.section-videos');

    // Function to pause videos and adjust classes
    function pauseVideos() {
      videos.forEach(function(video) {
        video.pause();
      });
      playPauseButtons.forEach(function(button) {
        button.classList.remove('pause');
      });
    }

    // Create an Intersection Observer
    let observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
            if (window.innerWidth <= 768) {
              playSelectedVideo();
              // Add an event listener to play the selected video when the cell changes
              flkty.on('cellSelect', function () {
                playSelectedVideo();
              });
            }
            else{
              // Trigger the playSelectedVideo function on load
              playSelectedVideo();
            }
        } else {
          pauseVideos();
        }
      });
    });

    // Observe the section element
    observer.observe(section);
  }

  // Function to play the video in the selected cell
  function playSelectedVideo() {
    // Pause all videos in the carousel
    let videos = document.querySelectorAll('.main-carousel-videos video');
    videos.forEach(function (video) {
      video.pause();
    });

    // Pause all videos in the carousel
    let playButtons = document.querySelectorAll('.section-videos .custom-play-button');
    playButtons.forEach(function (btn) {
      btn.classList.remove('pause');
    });

    // Autoplay the video on the active slide
    let activeSlide = flkty.selectedElement;

    let activeSlidePlayBtn = activeSlide.querySelector('.section-videos .custom-play-button');
    let activeVideo = activeSlide.querySelector('video');

    if (activeVideo.paused) {
      // Play the clicked video
      activeVideo.play();
      activeSlidePlayBtn.classList.add('pause');
    } else {
      // Pause the clicked video
      currentVideo.pause();
      activeSlidePlayBtn.classList.remove('pause');
    }
  }

  // Call the playPauseVideoOnScroll function
  playPauseVideoOnScroll();
});
